// Lazy-loads a heavy vendor library bundle (hls.js / livekit-client) the first
// time a controller actually needs it, instead of shipping it in the universal
// application.js. The bundle exposes its library on `window` (see hls_vendor.js
// / livekit_vendor.js). The digested URL comes from a <meta name="js-<name>">
// tag (shared/_lazy_js_meta), rendered in layouts that host video/live pages.
//
// IMPORTANT: the Stimulus controllers themselves stay in the normal manifest, so
// they register/connect exactly as before — only the big library is deferred.
// Returns a cached Promise that resolves once the global is available.

const cache = {}

export function loadVendor(name) {
  if (cache[name]) return cache[name]

  const url = document.querySelector(`meta[name="js-${name}"]`)?.content
  if (!url) {
    return Promise.reject(new Error(`[load_vendor] missing <meta name="js-${name}">`))
  }

  cache[name] = new Promise((resolve, reject) => {
    const script = document.createElement("script")
    script.src = url
    script.async = true
    script.onload = () => resolve()
    script.onerror = () => { delete cache[name]; reject(new Error(`[load_vendor] failed to load ${url}`)) }
    document.head.appendChild(script)
  })
  return cache[name]
}
